// extracted by mini-css-extract-plugin
export default {"recommendations":"WeRecommend_recommendations__kVDNJ"};